import { keyDeFactura } from "./comisionEdificiosUtil";

/**
 * Fuente ÚNICA del % de APX (segunda capa de intermediación de Publicis, ver 7.20).
 * Extraído de `getApxMonto` (Fase A2a) para poder congelarlo al facturar (Fase A1+).
 *
 * Gate por `opp.apx_id` (NUNCA por año ni por agencia): 0 si es null/inválido; si no, el % sale de
 * `intermediarios[apx_id].comision` resuelto **por id** (regla 10.7; hoy id 126 = 9). Shape-agnostic
 * igual que `getApxMonto`: acepta `intermediarios` como array u objeto-mapa (`Object.values`), sin
 * filtro de país porque el id de APX es único.
 *
 * Devuelve el porcentaje (ej. 9); 0 si no hay apx_id o no resuelve el intermediario.
 */
export const resolverPorcentajeApx = (opp, intermediarios, pctMap = null) => {
  // A3 (7.22): % congelado si hay foto; si no, vivo.
  const congelado = pctMap?.get(keyDeFactura(opp));
  if (congelado) return congelado.apx;
  if (opp?.apx_id == null) return 0;
  const apxId = parseInt(opp.apx_id, 10);
  if (isNaN(apxId)) return 0;
  const arr = Array.isArray(intermediarios) ? intermediarios : Object.values(intermediarios || {});
  const inter = arr.find((i) => i.id === apxId);
  return inter?.comision || 0;
};
